import * as React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import {css} from "@emotion/css";
import Pagination from '@mui/material/Pagination';
import {Skeleton} from "@mui/material";
// import emptyList from "../../assets/lottie/notFund.json"
import emptyList from "../../../assets/lottie/empty-list_1.json"
import {Player} from "@lottiefiles/react-lottie-player";
import "./SelectionTable.css"
import {dropFromList} from "../raikoMultiSelectTable/ArrayHelper";
import {useSnackbarDispatcher} from "../../../context/SnackBarContext";
import {useState} from "react";


function EnhancedTableHead({isSingleSelect = false, onSelectAllClick, numSelected, rowCount, header}) {
    return (
        <TableHead id={"selectionTableHeader"}>
            <TableRow>
                <TableCell padding="checkbox">
                    {!isSingleSelect && <Checkbox
                        color="primary"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />}
                </TableCell>
                {header.map((column) => (
                    <TableCell
                        key={column.id}
                    >
                        {column.label}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    header: PropTypes.array.isRequired,
    numSelected: PropTypes.number.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    rowCount: PropTypes.number.isRequired,
};


const SelectionTable = (
    {
        isSingleSelect,
        header,
        data,
        isLoading = false,
        pageCount = 0,
        handlePaginationChange,
        selected,
        setSelected
    }) => {
    const snackbar = useSnackbarDispatcher()

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            /*const newRowSelected = data.map((n) => n.id);
            setSelected(newRowSelected);*/
            let newRowSelected = []
            data.map((item, index) => {
                newRowSelected.push({id: item.id, title: item.title})
            })
            setSelected(newRowSelected)
            console.log("new selected is ", newRowSelected, "  selected is ", selected)
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, id, title) => {

        if (isSingleSelect)
            handleSelectSingleSelectItem(id, title);
        else
            handleSelectMultiSelectItem(id, title);
    };

    function handleSelectSingleSelectItem(id, title) {
        let selectedIndex = -1

        selected.map((item, index) => {
            if (item && item.id === id) {
                selectedIndex = index
            }
        })

        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected.push({id, title})
        } else {
            newSelected = dropFromList(selected, selectedIndex)
        }

        setSelected(newSelected);
    }

    function handleSelectMultiSelectItem(id, title) {
        let selectedIndex = -1

        selected.map((item, index) => {
            if (item && item.id === id) {
                selectedIndex = index
            }
        })

        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, {id, title});
        } else {
            newSelected = dropFromList(selected, selectedIndex)
        }

        setSelected(newSelected);
    }

    const isSelected = (id) => {
        // selected.indexOf(id) !== -1
        let selectedState = -1
        selected.map((item, index) => {
            if (item && item.id && item.id === id) {
                selectedState = index
            }
        })

        return selectedState !== -1
    };

    const [page, setPage] = useState(0);

    return (
        <section className={`${css`
          flex-grow: 1 !important;
          overflow-y: hidden;
          overflow-x: scroll !important;
          max-width: 95vw !important;
        `}`}>
            {
                data.length > 0 && !isLoading ?
                    <div className={css`
                      display: flex;
                      flex-direction: column;
                    `}>
                        <TableContainer id="checkBoxSelectionTable">
                            <Table stickyHeader
                                   sx={{minWidth: 750}}
                                   aria-labelledby="tableTitle"
                            >
                                <EnhancedTableHead
                                    isSingleSelect={isSingleSelect}
                                    header={header}
                                    numSelected={selected.length}
                                    onSelectAllClick={handleSelectAllClick}
                                    rowCount={data.length}
                                />
                                <TableBody>
                                    {data.map((row, index) => {
                                        const isItemSelected = isSelected(row.id);
                                        const labelId = `enhanced-table-checkbox-${index}`;

                                        return (
                                            <TableRow
                                                hover
                                                onClick={(event) => handleClick(event, row.id, row.title)}
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.id}
                                                selected={isItemSelected}
                                                className='cursorPointer'
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={isItemSelected}
                                                        inputProps={{
                                                            'aria-labelledby': labelId,
                                                        }}
                                                    />
                                                </TableCell>
                                                {header.map((column) => {
                                                    const value = row[column.id]
                                                    return (
                                                        <TableCell
                                                            key={column.id}
                                                            align={column.align}
                                                            className={
                                                                typeof value === 'object' ?
                                                                    css`cursor: default !important;` : ``
                                                            }
                                                            component="th"
                                                            id={labelId}
                                                            scope="row"
                                                            padding="none"
                                                        >
                                                            {value}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className={css`
                          width: 100%;
                          display: flex;
                          justify-content: center;
                          align-content: center;
                          margin-top: 16px;
                          direction: ltr;
                        `}>
                            <Pagination
                                count={pageCount}
                                onChange={(event, value) => {
                                    setPage(value)
                                    handlePaginationChange(value - 1)
                                }}
                                page={page}
                                color="primary"
                                showFirstButton showLastButton
                                className={pageCount && pageCount > 0 ? "" : css`display: none`}
                            />
                        </div>
                    </div>
                    :
                    <div className='w-100 h-100' style={{display: 'grid', placeItems: 'center'}}>
                        {
                            isLoading ?
                                <>
                                    <Box className={css`width: 100%;
                                      padding: 0 16px;
                                      gap: 16px;
                                      display: flex;
                                      flex-direction: column`}>
                                        <Skeleton variant="rectangular" className={css`padding: 32px`}/>
                                        <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                                        <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                                        <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                                        <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                                        <Skeleton variant="rectangular" className={css`padding: 16px`}/>
                                    </Box>
                                </> :
                                <section className={css`
                                  margin: 0 16px !important;
                                  width: 100%;
                                `}>
                                    <div className={css`
                                      display: flex;
                                      align-items: center;
                                      justify-content: center;
                                      flex-direction: column;
                                      border: 2px dashed var(--outlined-input-border-color);
                                      transition: var(--base-transition);
                                      border-radius: var(--default-border-radius);
                                      margin: 0 16px !important;
                                      padding: 16px 8px !important;
                                    `}>
                                        <Player
                                            src={emptyList}
                                            loop
                                            autoplay
                                            style={{height: '200px', width: '200px'}}
                                        />
                                        <span
                                            className={css`
                                              font-size: var(--text-size-medium);
                                              color: var(--color-text);
                                              margin: 8px 0;
                                              transition: var(--base-transition);
                                            `}>هیچ اطلاعاتی یافت نشد !</span>
                                        <span
                                            className={css`
                                              font-size: var(--text-size-default);
                                              color: var(--color-variant);
                                              margin: 8px 0;
                                              transition: var(--base-transition);
                                            `}>
                                    فیلتر ها را تغییر دهید یا از کلمات متداول تر برای جستجو استفاده نمایید.
                                </span>

                                    </div>

                                </section>
                        }

                    </div>
            }

        </section>
    )
};
export default SelectionTable;
SelectionTable.propType = {
    header: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired
}